import { darkPalette } from "../palette";

export const MuiButton = {
  MuiButton: {
    root: {
      textTransform: "none",
    },
    outlined: {
      border: "10px solid",
      borderColor: "red",
      color: darkPalette.primary.main,
      "&.Mui-disabled": {
        color: darkPalette.primary.main,
        border: "1px solid",
        borderColor: darkPalette.primary.main,
        opacity: ".25",
      },
    },
    contained: {
      "&:disabled": {
        backgroundColor: darkPalette.primary.main,
        color: darkPalette.text.primary,
        opacity: "0.25",
      },
    },
  },
};
